import React from "react";
import { routes } from "../configs/configNavLink";
import Layout from "../pages/Layout";
import Profile from "../pages/profile";
import LoginAdmin from "../admin/Auth";
// import ResetPassword from "../admin/Auth/ResetPassword";
import { RequireAdminAuth } from "../admin/plugins/RequireAuth";
import Sale from "../pages/presale";
import SharesAdmin from "../pages/presale/AdminShares";
import Vesting from "../pages/vesting";
import AboutUs from "../pages/about";
import { PresaleProvider } from "../scripts/usePresale";
import LayoutWithOutConnect from "../pages/Layout/LayoutWithOutConnect";
import Admin from "../pages/admin";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    component: <LayoutWithOutConnect />,
    attributes: {
      path: routes.admin,
      id: "LayoutWithOutConnect",
    },
    children: [
      {
        header: "Admin",
        component: (
          <RequireAdminAuth>
            <Admin />
          </RequireAdminAuth>
        ),
        attributes: {
          path: routes.admin,
          id: "admin",
        },
      },
      {
        header: "login",
        component: <LoginAdmin />,
        attributes: {
          path: routes.loginAdmin,
          id: "loginAdmin",
        },
      },
    ],
  },
  {
    component: <LayoutWithOutConnect />,
    attributes: {
      path: routes.aboutUs,
      id: "LayoutWithOutConnectAbout",
    },
    children: [
      {
        header: "About Us",
        component: <AboutUs />,
        attributes: {
          path: "",
          id: "aboutUs",
        },
      },
    ],
  },
  {
    component: <Layout />,
    attributes: {
      path: "/",
      id: "Layout",
    },
    children: [
      // {
      //   header: "Map",
      //   component: <Map />,
      //   attributes: {
      //     path: routes.map,
      //     id: "Map",
      //   },
      // },
      // {
      //   header: "Proposal",
      //   component: (
      //     <BallotProvider>
      //       <DigitalShare active={digitalShareTabs.PROPOSAL} />
      //     </BallotProvider>
      //   ),
      //   attributes: {
      //     path: routes.proposal,
      //     id: "proposal",
      //   },
      // },
      // {
      //   header: "Revenues",
      //   component: (
      //     <BallotProvider>
      //       <DigitalShare active={digitalShareTabs.REVENUE} />
      //     </BallotProvider>
      //   ),
      //   attributes: {
      //     path: routes.revenues,
      //     id: "revenues",
      //   },
      // },
      // {
      //   header: "Events",
      //   component: <Events />,
      //   attributes: {
      //     path: routes.events,
      //     id: "Events",
      //   },
      // },
      // {
      //   header: "Submit Events",
      //   component: <SubmitEvent />,
      //   attributes: {
      //     path: routes.submitevents,
      //     id: "SubmitEvent",
      //   },
      // },
      {
        header: "Profile",
        component: <Profile />,
        attributes: {
          path: routes.profile,
          id: "Profile",
        },
      },
      // {
      //   header: "Edit Profile",
      //   component: <EditProfile />,
      //   attributes: {
      //     path: routes.editProfile,
      //     id: "EditProfile",
      //   },
      // },

      {
        header: "sale",
        component: (
          <PresaleProvider>
            <Sale />
          </PresaleProvider>
        ),
        attributes: {
          index: true,
          id: "sale",
        },
      },
      {
        header: "admin",
        component: <SharesAdmin />,
        attributes: {
          path: routes.sharesAdmin,
          id: "admin",
        },
      },
      {
        header: "vesting",
        component: <Vesting />,
        attributes: {
          path: routes.vesting,
          id: "vesting",
        },
      },
      // {
      //   header: "Digital Share Sale",
      //   component: (
      //     <NftPresaleProvider>
      //       <NftPresale />
      //     </NftPresaleProvider>
      //   ),
      //   attributes: {
      //     path: routes.NftPresale,
      //     id: "nftPresale",
      //   },
      // },
      // {
      //   header: "Land Profile",
      //   component: (
      //     <ThemeProvider theme={theme}>
      //       <LandPage />
      //     </ThemeProvider>
      //   ),
      //   attributes: {
      //     path: routes.land,
      //     id: "land",
      //   },
      // },
      // {
      //   header: "Edit Land",
      //   component: (
      //     <ThemeProvider theme={theme}>
      //       <EditLand />
      //     </ThemeProvider>
      //   ),
      //   attributes: {
      //     path: routes.editLand,
      //     id: "land-edit",
      //   },
      // },
    ],
  },

  {
    component: <>Not Found</>,
    attributes: {
      path: "*",
      id: "notFound",
    },
  },
];
